import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_JURISDICTION_AREA,
  JurisdictionArea,
} from './jurisdictionArea.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getJurisdictionAreaList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<JurisdictionArea>> {
  return http.get(`${API_PATH_JURISDICTION_AREA}/${deliveryFunctionId}`);
}

export function createJurisdictionArea(
  deliveryFunctionId: string,
  body: WithAuditDetails<Partial<JurisdictionArea>>,
): AxiosPromise<ServerResponse<JurisdictionArea>> {
  return http.post(`${API_PATH_JURISDICTION_AREA}/${deliveryFunctionId}`, body);
}

export function deleteJurisdictionArea(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<JurisdictionArea>> {
  return http.delete(`${API_PATH_JURISDICTION_AREA}/${deliveryFunctionId}/${id}`);
}
